<template lang="pug">
  f7-app(:params="f7params")

    f7-view(main)

      playback-video(
        :src="playback.src",
        :opened="playback.opened"
        @close='playback.opened = false'
      )
</template>

<script>
import routes from './router'
import PlaybackVideo from '@/pages/Public/PlaybackVideo'
import { EventBus } from '@/utils/event-bus'

const pageTitles = {
  '/students': { title: '生徒一覧' },
  '/curriculums': { title: 'カリキュラム' },
}

export default {
  components: {
    PlaybackVideo,
  },
  data() {
    return {
      f7params: {
        name: 'SpotomoDance',
        theme: 'auto',
        routes: routes,
      },
      playback: {
        src: null,
        opened: false,
      },
    }
  },
  methods: {
    showPlaybackVideo(videoSrc) {
      this.playback.src = videoSrc
      this.playback.opened = true
    },
    replacePageTitleUsingForInApp() {
      const path = location.pathname.replace('/web', '')
      if (pageTitles[path]) {
        document.title = pageTitles[path].title
      }
    },
  },
  created() {
    this.replacePageTitleUsingForInApp()
    EventBus.$on('video-playback:show', this.showPlaybackVideo)
  },
  beforeDestroy() {
    EventBus.$off('video-playback:show', this.showPlaybackVideo)
  },
}
</script>
